<div class="verify__summary">
  <div class="verify__content">
    <div class="grid">
      <div class="grid__unit s-4-4 m-6-12" privacySensitive>
        <div [cypress]="'company'" class="grid__unit s-4-4">
          <nes-heading tag="h2" size="base" weight="normal" class="nes-mb-2">{{
            "VERIFY.ORGANISATION_DETAILS" | translate
          }}</nes-heading>
          <nes-heading tag="h2" size="base" class="nes-mb-2">
            <strong>{{ company.name }}</strong>
          </nes-heading>
          <div>{{ "KVK" | translate }}: {{ company.kvkNumber }}</div>
          <div>
            {{ company.address.street }} {{ company.address.houseNumber }}
          </div>
          <div>{{ company.address.postcode }} {{ company.address.city }}</div>

          <a class="link" [cypress]="'edit_user'" (click)="edit.emit()">
            <nes-text weight="bold" size="sm" color="blue-500">
              {{ "VERIFY.BUTTON.EDIT_COMPANY" | translate }}
            </nes-text>
          </a>
        </div>
      </div>
      <div class="grid__unit s-4-4 m-6-12" privacySensitive>
        <ng-container *ngIf="company.representative as representative">
          <div class="grid__unit s-4-4" [cypress]="'representative'">
            <nes-heading tag="h2" size="base" weight="normal" class="nes-mb-2">
              {{ "VERIFY.REPRESENTATIVE" | translate }}
            </nes-heading>
            <div>
              {{ representative | displayName | async }}
            </div>
            <div>{{ representative.email }}</div>
          </div>
          <div class="grid__unit s-4-4" [cypress]="'contact_person'">
            <nes-heading tag="h2" size="base" weight="normal" class="nes-mb-2">
              {{ "VERIFY.CONTACT_PERSON" | translate }}
            </nes-heading>
            <ng-container
              *ngIf="company.contactPerson as contactPerson; else default"
            >
              <div>
                {{ contactPerson | displayName | async }}
              </div>
              <div>{{ contactPerson.email }}</div>
            </ng-container>
            <ng-template #default>
              <div>
                {{ representative | displayName | async }}
              </div>
              <div>{{ representative.email }}</div>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
